import type en_gb from "../translations/en-GB/translations.json";
export const localeMap = {
    "ar-sa": "ﺔﻴﺐﺮﻌﻠﺍ",
    az: "azərbaycan",
    be: "беларуская",
    cs: "čeština",
    da: "dansk",
    de: "Deutsch",
    el: "Ελληνικά",
    "en-gb": "English",
    es: "Español",
    "es-mx": "Español (mx)",
    et: "eesti",
    fi: "suomi",
    fr: "français",
    hr: "hrvatski",
    hu: "magyar",
    hy: "Հայերեն",
    ka: "ქართული",
    it: "Italiano",
    lt: "lietuvių",
    lv: "latviešu",
    ne: "नेपाली",
    nl: "Nederlands",
    "nl-be": "Nederlands (be)",
    no: "Norsk",
    pl: "polski",
    pt: "Português",
    ro: "Română",
    ru: "русский",
    si: "සිංහල",
    sk: "slovenčina",
    "sr-latn": "српски језик",
    sv: "Svenska",
    sw: "Kiswahili",
    th: "ไทย",
    tr: "Türkçe",
    uk: "Українська",
    ur: "اردو",
    vi: "Tiếng Việt",
    zh: "繁體中文",
};

export const getHumanReadableLocale = (locale: AvailableLocale) => localeMap[locale];

export const getLocaleArray = () => {
    const array: Array<{id: string; title: string}> = [];
    const keys = Object.keys(localeMap);
    keys.forEach((key) => {
        array.push({
            id: key,
            title: localeMap[key as AvailableLocale],
        });
    });
    return array;
};

export type Translations = typeof en_gb;
export type TranslationKey = keyof Translations;
export type AvailableLocale = keyof typeof localeMap;
